import React, { lazy, PureComponent, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Storage from "browserstorage-ttl";
import { Spin, Modal, Button, Icon, Result } from "antd";
import { connect } from "dva";
// import userflow from "userflow.js";
import { Security, LoginCallback } from "@okta/okta-react";
// import { getAPIConfig } from "../service-config";

// import Login from "./components/LoggedOutPages/Login";
// import MasterSignup from "./components/LoggedOutPages/MasterSignup";
// import ConfirmSignup from "./components/LoggedOutPages/ConfirmSignup";

//import AttachmentView from "./components/common/AttachmentView";
const AttachmentView = lazy(() =>
  import("./components/LoggedOutPages/AttachmentView")
);
import { get } from "lodash";

import "./theme.less";
import "./app.scss";

import { TokensApi, UsersApi } from "./services/generated-sdk";
import { getAPIConfig } from "./service-config";
import CenterElement from "./components/common/layout/CenterElement";
// import PageWrapper from "./components/wrappers/PageWrapper";
const PageWrapperSwitch = lazy(() =>
  import("./components/wrappers/PageWrapperSwitch")
);
const ModalWrapperSwitch = lazy(() =>
  import("./components/wrappers/ModalWrapperSwitch")
);

const LoggedOutWrapper = lazy(() =>
  import("./components/wrappers/LoggedOutWrapper")
);
// const LoggedOutWrapper = lazy(() => import("./components/wrappers/Paper"));
// import Page

// pages
// const MilestoneIndex = lazy(() => import("./components/Milestones/MilestoneIndex"));

const Login = lazy(() => import("./components/LoggedOutPages/Newlogin"));

// const MapFields = lazy(() => import("./components/test_case_pages/Import/MapFields"));
// const ImportInfo = lazy(() => import("./components/test_case_pages/Import/ImportInfo"));
import { StoreProvider } from "./globalStore";

// const ImportStatus = lazy(() => import("./components/test_case_pages/Import/ImportStatus"));
// const GenericForm = lazy(() => import("./templates/FormTemplate"));
import {
  oktaAuthConfig,
  oktaSignInConfig,
  getOktaAuthConfig,
  getOktaSignInConfig
} from "./utils/okta-config";
import OktaSignPage from "./components/LoggedOutPages/OktaSigninPage";
import SsoLogin from "./components/LoggedOutPages/SsoLogin";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
const oktaAuthConfig2 = getOktaAuthConfig();
const oktaSignInConfig2 = getOktaSignInConfig();
// let oktaAuth = null;
// const oktaAuth = oktaAuthConfig2 && oktaAuthConfig2.clientId.length ? new OktaAuth(oktaAuthConfig2) : null;
let oktaAuth = new OktaAuth(oktaAuthConfig);

const getOktaAuthObject = () => {
  if (!oktaAuth) {
    let oktaConfResult = getOktaAuthConfig();
    if (
      oktaConfResult &&
      oktaConfResult.clientId &&
      oktaConfResult.clientId.length
    ) {
      oktaAuth = new OktaAuth(oktaConfResult);
    }
  }
  return oktaAuth;
};

// const ExecViewPage = lazy(() =>
//   import("./components/ExecutionViewPage/TestPlanView")
// );

const UserRegistration = lazy(() =>
  import("./components/LoggedOutPages/UserRegistration")
);

const AcceptInvitaion = lazy(() =>
  import("./components/LoggedOutPages/AcceptInvitaion")
);
const StartTrial = lazy(() => import("./components/LoggedOutPages/StartTrial"));
const ForgotPassword = lazy(() =>
  import("./components/LoggedOutPages/ForgotPassword")
);
const VerifyEmail = lazy(() => import("./components/common/VerifyEmail"));

const ResetPassword = lazy(() =>
  import("./components/LoggedOutPages/ResetPassword")
);

import { closeDialogue, handleError, inIframe, useQuery } from "./utils/common";

class ModalSwitchStatic extends PureComponent<
  any,
  { loading: boolean; user: object | false; localStorageError: boolean }
> {
  // We can pass a location to <Switch/> that will tell it to
  // ignore the router's current location and use the location
  // prop instead.
  //
  // We can also use "location state" to tell the app the user
  // wants to go to `/img/2` in a modal, rather than as the
  // main page, keeping the gallery visible behind it.
  //
  // Normally, `/img/2` wouldn't match the gallery at `/`.
  // So, to get both screens to render, we can save the old
  // location and pass it to Switch, so it will think the location
  // is still `/` even though its `/img/2`.
  previousLocation = this.props.location;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user: {},
      localStorageError: false
    };
  }

  setLocalStorage = () => {
    const navState = localStorage.getItem("SIDER_OPEN_STATE");
    this.props.dispatch({
      type: "app/setNavExpanded",
      payload: {
        status: navState !== "NO"
      }
    });
  };

  logUserIn = async () => {
    // try {
    //   userflow.setCustomNavigate(url => this.props.history.push(url));
    // } catch (e) {
    //   console.log({ userflow_error: e });
    // }
    try {
      this.setLocalStorage();
    } catch (e) {
      if (inIframe() && e && e.code && e.code == 18) {
        this.setState({ localStorageError: true });
        //alert("Please enable third party cookies. So, application can work correctly. To enable third party cookies, please check right corner of the address bar for this icon ");
        return;
      }
    }

    // if (!oktaAuth) {
    //   console.log(
    //     "oktaAuth is not initiated yet.......................",
    //     this.props.location
    //   );
    //   getOktaAuthObject();
    // }
    let res = null;
    // if (oktaAuth) {
    //   res = await oktaAuth.isAuthenticated();
    // }
    // // alert(res);
    if (res) {
      // const accessToken = oktaAuth.getIdToken();
      // this.loginFromJwt(accessToken);
      // return;
    } else {
      try {
        let user = false;
        // debugger;
        let raw = Storage.get("TC_USER");
        if (typeof raw == "object") {
          user = raw;
        }
        if (typeof raw == "string") {
          user = JSON.parse(raw);
        }
        if (user) {
          // debugger;
          this.props.dispatch({
            type: "app/checkIfSessionExists",
            payload: {
              callback: user => {
                if (!user)
                  this.setState({ user }, () =>
                    this.setState({ loading: false })
                  );
                else {
                  this.setState({ loading: false });
                }
              }
            }
          });
          // Set false if something went wrong
          this.loginTimeOut(100000);
        } else {
          const { state = {} } = this.props.location;
          if (state.jwt) {
            this.loginFromJwt(state.jwt);
          } else {
            // check for public URL
            if (
              window.location.search &&
              window.location.search.length > 10 &&
              window.location.search.indexOf("public_token") > 0
            ) {
              // console.log("public token found.....");
              try {
                let searchStrArr = window.location.search.split("&");
                let publicToken = null;
                if (searchStrArr.length > 1) {
                  searchStrArr.forEach((str, indx) => {
                    if (str.indexOf("public_token") >= 0) {
                      publicToken = str.split("=")[1];
                    }
                  });
                } else {
                  publicToken = searchStrArr[0].split("=")[1];
                }
                if (publicToken && publicToken.length) {
                  if (window.document.location.pathname != "/") {
                    //debugger;
                    const reqURL = window.document.location.pathname;
                    const search = window.document.location.search;
                    sessionStorage.setItem("TC_REDIR_URL", reqURL);
                    sessionStorage.setItem("TC_REDIR_SEARCH", search);
                    //Storage.set("TC_REDIR_URL", window.document.location.hash.replace('#', ''), 1);
                  }
                  await this.loginFromJwt(publicToken);
                  // return;
                }
              } catch (e) {
                console.log({ publicToken_error: e });
              }
            } else {
              console.log("public token not found..... proceed to login....");
              // try {
              //   if(window.jwt) {
              //     const api = new UsersApi();
              //     const userResult = await api.getMyUser();
              //     // if public token then redirect to login
              //     if (userResult && userResult.id === 0 && userResult.isGuest) {
              //       this.setState({ loading: false });
              //       this.props.dispatch({
              //         type: "app/logout",
              //         payload: {
              //           forceLogout: true
              //         }
              //       });
              //       return;
              //     }
              //   }
              // } catch (e) {
              //   // console.log({e})
              // }

              this.setState({ loading: false });
              if (window.document.location.pathname != "/") {
                //debugger;
                const reqURL = window.document.location.pathname;
                const search = window.document.location.search;
                sessionStorage.setItem("TC_REDIR_URL", reqURL);
                sessionStorage.setItem("TC_REDIR_SEARCH", search);
                //Storage.set("TC_REDIR_URL", window.document.location.hash.replace('#', ''), 1);
              }
              // this.props.history.push("/login");
            }
          }
        }

        // this.setState({ loading: false });
      } catch (e) {
        // alert("Logging out...");
        // return;
        this.setState({ loading: false, user: null });
        if (window.document.location.pathname != "/") {
          //debugger;
          const reqURL = window.document.location.pathname;
          const search = window.document.location.search;
          sessionStorage.setItem("TC_REDIR_URL", reqURL);
          sessionStorage.setItem("TC_REDIR_SEARCH", search);
          //Storage.set("TC_REDIR_URL", window.document.location.hash.replace('#', ''), 1);
        }
        this.props.history.push("/login");
        return;
      }
    }
  };

  componentDidMount() {
    // getOktaAuthObject();
    this.logUserIn();
  }

  componentWillUpdate(nextProps) {
    let { location } = this.props;
    // getOktaAuthObject();
    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== "POP" &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }
  }

  loginFromJwt = async jwt => {
    this.setState({ loading: true });
    const api = new UsersApi(getAPIConfig(jwt));
    try {
      const user = await api.getMyUser();
      const userAltFormat = {
        jwt,
        user: user
      };
      // validate token for requested resource - if passed then allow else redirect to login
      if (user && user.id === 0 && user.isGuest) {
        let isValidRequest = true;
        let searchPart = sessionStorage.getItem("TC_REDIR_SEARCH");
        if (
          (window.location.search &&
            window.location.search.length > 10 &&
            window.location.search.indexOf("public_token") > 0) ||
          (searchPart && searchPart.indexOf("public_token") > 0)
        ) {
          const tokensApi = new TokensApi();
          try {
            let tkResult = await tokensApi.validatePublicToken({
              publicToken: jwt
            });
            if (
              tkResult &&
              tkResult.status &&
              tkResult.message &&
              tkResult.message.length
            ) {
              let tokenPayload = JSON.parse(tkResult.message);
              let tokenURL = null;
              // need to add validation handling here for other public entities in future
              if (tokenPayload && tokenPayload["entity"]) {
                if (tokenPayload["entity"] == "testplan") {
                  tokenURL = `/project/${tokenPayload["project"]}/test_plans/${
                    tokenPayload["entityId"]
                  }/view`;
                }
                sessionStorage.setItem("TCPT", JSON.stringify(tokenPayload));
              }
              if (
                tokenURL &&
                window.document.location.pathname.indexOf(tokenURL) >= 0
              ) {
                // console.log("valid request....");
              } else {
                // console.log("invalid request....redirect to login page");
                isValidRequest = false;
              }
            } else {
              isValidRequest = false;
            }
          } catch (e) {
            isValidRequest = false;
          }
        } else {
          isValidRequest = false;
        }
        if (!isValidRequest) {
          //public_token not found in URL or not a valid public url
          sessionStorage.setItem("TC_REDIR_URL", "/");
          sessionStorage.setItem("TC_REDIR_SEARCH", "");
          this.setState({ loading: false });
          this.props.history.push("/");
          return;
        }
      }
      this.props.dispatch({
        type: "app/afterLogin",
        payload: {
          user: userAltFormat,
          storeSession: true,
          remember: user && user.id === 0 ? false : true,
          callback: success => {
            this.setState({ loading: false });
            if (!success) {
              this.props.history.push("/login");
            } else {
              if (user && user.id === 0 && user.isGuest) {
                // console.log("guest session.......");
                const reqURL = sessionStorage.getItem("TC_REDIR_URL");
                const search = sessionStorage.getItem("TC_REDIR_SEARCH");
                sessionStorage.removeItem("TC_REDIR_URL");
                sessionStorage.removeItem("TC_REDIR_SEARCH");
                this.props.history.push(`${reqURL}${search}`);
                return;
              }
            }
          }
        }
      });

      // this.loginTimeOut(100 * 1000);
      //storeUserSession(userAltFormat, expiry);
      this.props.history.push("/tasks");
      //redirectToAccount();
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  };

  customAuthHandler = () => {
    this.props.history.push("/okta-login");
  };

  loginTimeOut = (timeout = 5000) => {
    setTimeout(() => {
      if (this.state.loading) {
        // return;
        this.setState({ loading: false });
        if (window.document.location.pathname != "/") {
          //debugger;
          const reqURL = window.document.location.pathname;
          const search = window.document.location.search;
          sessionStorage.setItem("TC_REDIR_URL", reqURL);
          sessionStorage.setItem("TC_REDIR_SEARCH", search);
          //Storage.set("TC_REDIR_URL", window.document.location.hash.replace('#', ''), 1);
        }
        this.props.history.push("/login");
      }
    }, timeout);
  };

  _onFeatureModalClosed = () => {
    this.props.dispatch({
      type: "app/setUpgradeModal",
      payload: { visible: false, title: "", content: null, feature: null }
    });
  };

  _upgradePlan = (featureName?) => {
    this._onFeatureModalClosed();
    if (
      featureName &&
      ["inbuilt", "inbuiltrequirement", "testcaseapproval"].indexOf(
        featureName
      ) >= 0
    ) {
      this.props.history.push("/select_plan/business/2");
      return;
    }
    this.props.history.push("/upgrade_plan");
  };

  restoreOriginalUri = async (_oktaAuth, originalUri) => {
    this.props.history.replace(
      toRelativeUrl(originalUri || "/", window.location.origin)
    );
  };

  // customAuthHandler = () => {
  //   this.props.history.push("/okta-login");
  // };
  render() {
    if (this.state.localStorageError === true) {
      return (
        <Result
          status="warning"
          title={`You need to turn on third party cookies for Test Collab`}
          subTitle={
            <span>
              To turn on third party cookies, check for this{" "}
              <Icon type="eye-invisible" /> icon in your address bar or check in
              your browser settings
            </span>
          }
        />
      );
    }

    let { location, app } = this.props;
    let isModal = false;
    // not initial render
    let entry = true;

    if (this.state.loading === true) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <Spin />
        </div>
      );
    }

    // @TODO remove me later

    // React.useMemo(() => {
    location.state ? location.state.entry || false : false;
    if (location.pathname === "/") {
      return <Redirect to="/tasks" />;
    }
    if (this.state.user && this.state.user["id"] && !this.state.user["name"]) {
      if (!location.pathname.includes("/company_setup")) {
        //Reset
        this.setState({ user: {} });

        return <Redirect to="/company_setup" />;
      }
    }

    entry = location.state ? location.state.entry || false : false;

    isModal = !!(
      (location.state &&
        location.state.modal &&
        this.previousLocation !== location) ||
      (location.state && location.state.entry == true)
    );

    isModal = !!app.isModal;

    if (entry) {
      this.previousLocation = location;
    }

    location = isModal && entry == false ? this.previousLocation : location;
    // }, [location]);

    return (
      <div>
        <StoreProvider>
          <Suspense
            fallback={
              <CenterElement>
                <Spin />
              </CenterElement>
            }
          >
            <Modal
              visible={get(app, "featureModal.visible", false)}
              onCancel={this._onFeatureModalClosed}
              //onOk={this._upgradePlan}
              footer={null}
              // destroyOnClose
              closable
              okText="Upgrade"
              afterClose={this._onFeatureModalClosed}
              wrapClassName="upgrade_modal"
              //title={_.get(app, "featureModal.title", "Require upgrade")}
              title={null}
            >
              <div
                className="upgrade-modal"
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  paddingBottom: "20px"
                }}
              >
                <h2>{app.featureModal.title}</h2>
                <div
                  className="upgrade-content"
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    color: "#6f6f6f"
                  }}
                >
                  {app.featureModal.content ? (
                    <div>
                      {app.featureModal.content}
                      {app.featureModal.feature == "multiFilter" ? (
                        <span
                          className="icon_multifilter"
                          style={{ width: "100%", height: "500px" }}
                        >
                          {" "}
                        </span>
                      ) : null}
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
                {get(app, "loggedInUser.rank") === "Administrator" ? (
                  <>
                    {app.company.plan == "enterprise" ||
                    (app.featureModal.feature &&
                      [
                        "okta",
                        "sso",
                        "auditlog",
                        "passwordpolicies",
                        "dataexportsql"
                        // "inbuiltrequirement"
                      ].indexOf(app.featureModal.feature.toLowerCase()) >=
                        0) ? (
                      <Button
                        id="launch_intercom_link"
                        type="primary"
                        size="large"
                        // onClick={this._upgradePlan}
                        className="btn-success"
                        style={{ paddingLeft: "20px", marginTop: "20px" }}
                      >
                        Contact us
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        size="large"
                        onClick={e =>
                          this._upgradePlan(
                            app.featureModal.feature.toLowerCase()
                          )
                        }
                        className="btn-success"
                        style={{ paddingLeft: "20px", marginTop: "20px" }}
                      >
                        {" "}
                        Upgrade now{" "}
                        <Icon
                          type="star"
                          theme="filled"
                          style={{
                            color: "#f9d00a",
                            marginTop: "2px",
                            verticalAlign: "middle",
                            fontSize: "14px"
                          }}
                        />
                      </Button>
                    )}
                    {!app.company.trialOpted &&
                    app.company.plan == "free" &&
                    (!app.featureModal.feature ||
                      !(
                        app.featureModal.feature &&
                        [
                          "okta",
                          "sso",
                          "auditlog",
                          "passwordpolicies",
                          "dataexportsql"
                          // "inbuiltrequirement",
                          // "inbuilt",
                          // "testcaseapproval"
                        ].indexOf(app.featureModal.feature.toLowerCase()) >= 0
                      )) ? (
                      <div>
                        <a
                          href={`/select_plan/trial${
                            app.featureModal.feature == "testCaseApproval" ||
                            app.featureModal.feature == "inbuilt" ||
                            app.featureModal.feature == "inbuiltRequirement" ||
                            app.featureModal.feature == "testDataSets"
                              ? "-business"
                              : ""
                          }/2`}
                          style={{
                            color: "#00ca72",
                            display: "block",
                            marginTop: "10px"
                          }}
                        >
                          Try for free
                        </a>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <span>
                    <br />
                    <br />
                    Please contact your account administrator to get your
                    account upgraded!
                  </span>
                )}
              </div>
            </Modal>
            {oktaAuth ? (
              <Security
                oktaAuth={oktaAuth}
                // onAuthRequired={this.customAuthHandler}
                restoreOriginalUri={this.restoreOriginalUri}
                // restoreOriginalUri={(oktaAuth, originalUri) => {
                //   if (oktaAuth) {
                //     oktaAuth.isAuthenticated().then(res => {
                //       // console.log({ okta_auth_success: res });
                //       if (!res) {
                //         this.props.history.push("/okta-login");
                //       }
                //     });
                //     if (oktaAuth.isAuthenticated) {
                //     }
                //   }
                // }}
              >
                <Switch location={location}>
                  <Route exact path="/sso-login" component={SsoLogin} />
                  <Route
                    path="/okta-login"
                    render={() => (
                      <OktaSignPage
                        history={this.props.history}
                        config={oktaSignInConfig}
                      />
                    )}
                  />
                  <Route path="/okta-callback" component={LoginCallback} />

                  {/* <LoggedOutWrapper
                    exact
                    path="/start_trial"
                    component={StartTrial}
                  /> */}
                  <LoggedOutWrapper
                    exact
                    path="/reset-password"
                    component={ResetPassword}
                  />

                  <LoggedOutWrapper
                    exact
                    path="/acceptInvitaion/:inviteCode"
                    component={AcceptInvitaion}
                  />
                  <LoggedOutWrapper exact path="/login" component={Login} />
                  <LoggedOutWrapper
                    exact
                    path="/register/:inviteCode"
                    component={UserRegistration}
                  />
                  <LoggedOutWrapper
                    exact
                    path="/verifyEmail/:confirmation"
                    component={VerifyEmail}
                  />
                  <LoggedOutWrapper
                    exact
                    path="/users/forgotPassword"
                    component={ForgotPassword}
                  />
                  <LoggedOutWrapper
                    path="/attachment_view/:slug"
                    component={AttachmentView}
                  />
                  <PageWrapperSwitch
                    {...this.props}
                    entry={entry}
                    isModal={isModal}
                    previousLocation={this.previousLocation}
                  />
                </Switch>
              </Security>
            ) : (
              <Switch location={location}>
                <Route
                  path="/okta-login"
                  render={() => (
                    <OktaSignPage
                      history={this.props.history}
                      config={getOktaSignInConfig()}
                    />
                  )}
                />
                <Route path="/okta-callback" component={LoginCallback} />

                <Route exact path="/sso-login" component={SsoLogin} />

                {/* <LoggedOutWrapper
                  exact
                  path="/start_trial"
                  component={StartTrial}
                /> */}
                <LoggedOutWrapper
                  exact
                  path="/reset-password"
                  component={ResetPassword}
                />

                <LoggedOutWrapper
                  exact
                  path="/acceptInvitaion/:inviteCode"
                  component={AcceptInvitaion}
                />
                <LoggedOutWrapper exact path="/login" component={Login} />
                <LoggedOutWrapper
                  exact
                  path="/register/:inviteCode"
                  component={UserRegistration}
                />
                <LoggedOutWrapper
                  exact
                  path="/verifyEmail/:confirmation"
                  component={VerifyEmail}
                />
                <LoggedOutWrapper
                  exact
                  path="/users/forgotPassword"
                  component={ForgotPassword}
                />
                <LoggedOutWrapper
                  path="/attachment_view/:slug"
                  component={AttachmentView}
                />
                <PageWrapperSwitch
                  {...this.props}
                  entry={entry}
                  isModal={isModal}
                  previousLocation={this.previousLocation}
                />
              </Switch>
            )}
            <ModalWrapperSwitch />
          </Suspense>
        </StoreProvider>
      </div>
    );
  }
}

const ModalSwitch = connect(({ app }) => ({
  app: app
}))(ModalSwitchStatic);

export default ModalSwitch;
